import { Text } from "@mantine/core";

const TileContentText = ({ text }: { text: string | number }) => (
  <Text fz="2.25rem" lh={1.222} fw={600}>
    {text}
  </Text>
);

export default TileContentText;
